import { Spacing, Typography } from "@p0security/ui";
import { Link } from "react-router-dom";

const { Text } = Typography;

type Props = { to: string };

const P0SecurityFeaturesLink: React.FC<Props> = ({
  to = "https://p0.dev/blog",
}) => {
  return (
    <Spacing mt={10}>
      <Text>
        Learn more about P0’s built-in security features{" "}
        <Link to={to} target="_blank" rel="noreferrer">
          here
        </Link>
        .
      </Text>
    </Spacing>
  );
};

export default P0SecurityFeaturesLink;
